export default {
    translations: {
        menu: {
            home: 'Home',
            about: 'About',
            support_us: 'Experiences',
            join_us: 'Join Us',
            upcoming_events: "Upcoming events",
            team: 'Experiences',
            social_network: 'Social Media',
        },
        section_home: {
            title: "DON'T WORK HARD, WORK SMART!",
            button: "More about me!",
        },
        section_about: {
            title: "About me",
            description: `I'm Denis 'Velrino' Magalhães, and I'm 26 years old.

            I have been involved in technology since 2015.

            I have always had a passion for technology since I was a child.

            I began my career as a full-stack developer, aiming to understand how everything works (back-end, front-end, and DevOps) to consistently ensure the creation of high-quality products.

            In addition to my personal and professional growth, I have actively participated in events and learned from exceptional individuals.
        `,
            card_1_title: "+4,000 MEMBERS ON MEETUP",
            card_1_text: "We are always there promoting online and offline events",
            card_2_title: "NODEJS COURSE FOR BEGINNERS",
            card_2_text: "One of the largest online courses that has helped thousands of devs enter the market",
            card_3_title: "FROM BASIC TO ADVANCED NODEJS",
            card_3_text: "Delivered for free to the community",
        },
        section_experiences: {
            title: "Experiences",
            button: "Support us with your company",
        },
        section_voluntary: {
            title: "Join the community",
            button_1: "Become a volunteer",
            button_2: "Partnerships",
        },
        section_skills: {
            title: "Skills",
        },
        section_social: {
            title: "Social media",
        },
        section_upcoming_events: {
            title: "Upcoming events",
        },
    }
}